__turbopack_context__.v({
  "customInput": "RewriteWithAIPanel-module__M5OHAa__customInput",
  "customRow": "RewriteWithAIPanel-module__M5OHAa__customRow",
  "goButton": "RewriteWithAIPanel-module__M5OHAa__goButton",
  "list": "RewriteWithAIPanel-module__M5OHAa__list",
  "panel": "RewriteWithAIPanel-module__M5OHAa__panel",
  "panelClose": "RewriteWithAIPanel-module__M5OHAa__panelClose",
  "panelHeader": "RewriteWithAIPanel-module__M5OHAa__panelHeader",
  "panelPortaled": "RewriteWithAIPanel-module__M5OHAa__panelPortaled",
  "panelTitle": "RewriteWithAIPanel-module__M5OHAa__panelTitle",
  "promptButton": "RewriteWithAIPanel-module__M5OHAa__promptButton",
});
